// @module NetSuite
define('NetSuite.SuiteCommCPQ.Main.Core',[
        'NetSuite.SuiteCommCPQ.Main.Configuration', 'NetSuite.SuiteCommCPQ.Main.Debug', 'NetSuite.SuiteCommCPQ.Ext.Noscroll'
], function (Configuration, Debugger, ExtNoscroll) {
    //
    'use strict';
    //
    var cart, pdp, userProfile, entity, thisMainCore, pricelevel,
        cpqWindow,
        startNewTab =  Configuration.get('startNewTab'),
        basicTheme =  Configuration.get('basicTheme'),
        addOneByOne =  Configuration.get('addOneByOne'),
        configUrls = {},
        vcpqData = {},
        extensionEvents = {},
        /** @type {VCart} */
        vCart;
    //
    var Main_Core = {
        init: function(_cart, _pdp, _userProfile) {
            thisMainCore = this;
            cart = _cart;
            pdp = _pdp;
            vCart = new VCart(cart);
            userProfile = _userProfile;
            window.showSubmitLoader = showSubmitLoader;
            thisMainCore.setGlobal('cancelSubmit', function () {
                return cancelSubmit();
            });
            thisMainCore.setGlobal('clearCart', function () {
                return vCart.clear();
            });
            thisMainCore.setGlobal('isReady', function () {
                return !!configUrls.real;
            });
            setTimeout(function () {
                userProfile.getUserProfile().then(function(data){
                    entity = data.internalid;
                    pricelevel = data.pricelevel;
                    thisMainCore.setGlobal('getEntity', function () {
                        return entity;
                    });
                    thisMainCore.setGlobal('getPriceLevel', function () {
                        return pricelevel;
                    });
                    window.vscUserProfile = {
                        entity: data.internalid,
                        pricelevel: data.pricelevel
                    };
                });
            },0);
        },
        setUrl: function(url) {
            configUrls.real = url + '&start=SCA';
            Debugger.log('REAL URL', url);
        },
        launchConfig: function (options, hidden) {
            Debugger.log('VCPQ','Core : launchConfig');
            if (typeof userProfile === 'object') {
                userProfile.getUserProfile().then(function (userData) {
                    //
                    entity = userData.internalid;
                    Debugger.log('VCPQ','Core : userID = ' + entity);
                    _launch();
                });
            } else {
                Debugger.error('VCPQ','CPQ extension is not yet initialized');
            }
            //
            function _launch() {
                var sysOptions = ['productid','intid','configid','mchilds'], url;
                if (!configUrls.real) {
                    Debugger.error('launchConfig', 'Config Suitelet URL is not defined');
                    return ;
                }
                if (options.productid) {
                    url = configUrls.real+'&productid='+options.productid;
                    if (options.intid) {
                        url += '&intid='+options.intid;
                    }
                } else {
                    Debugger.error('launchConfig', 'Config Product is not specified');
                    return ;
                }
                // config record ID
                if (options.configid) {
                    url += '&cid='+options.configid;
                }
                // customer id
                if (options.entity)
                    entity = options.entity;
                if (entity) {
                    url += '&entity=' + entity;
                }
                // matrix item selected childs
                if (options.mchilds) {
                    url += '&mchilds='+options.mchilds;
                }
                // other parameters
                for (var key in options) {
                    if (sysOptions.indexOf(key) === -1) {
                        url += '&' + key + '=' + options[key];
                    }
                }
                if (basicTheme) {
                    url += '&theme=basic'
                }
                if (startNewTab) {
                    cpqWindow = window.open(url,'_blank');
                } else {
                    showCPQContainer(url, hidden);
                }
            }
        },
        closeConfig: function () {
            if (startNewTab) {
                if (cpqWindow && cpqWindow.close)
                    cpqWindow.close();
            } else {
                hideCPQContainer();
            }
        },
        postMessage: function (type, data) {
            var postData;
            Debugger.log('* postmessage to CPQ');
            if (typeof data === 'undefined') {
                postData = type; // no 2nd parameter - just send data as is
                if (typeof postData === 'object')
                    postData = JSON.stringify(postData);
            } else {
                postData = JSON.stringify({
                    type: type,
                    data: data
                });
            }
            if (cpqWindow && cpqWindow.postMessage) {
                cpqWindow.postMessage(postData, '*');
            } else {
                console.warn('CPQ window inaccessible');
            }
        },
        /**
         * Add listener for incoming messages (window)
         * @param {string} type - message type
         * @param {function} func - processing function
         * note: possible single parameter syntax (processing function)
         */
        addMessageListener: function(type, func) {
            var processorFunc, all = false;
            if (typeof type === 'function') {
                all = true;
                processorFunc = type;
            } else if (typeof func === 'function') {
                processorFunc = func;
            } else {
                Debugger.error('addMessageListener: syntax error');
            }
            //
            window.addEventListener('message', function (eventData) {
                var data = eventData.data;
                if (typeof data === 'string' && (data[0] == '{' || data[0] == '[')) {
                    try {
                        data = JSON.parse(data);
                    } catch(e) {
                        // not a JSON
                    }
                }
                if (all) {
                    processorFunc(data);
                } else {
                    if (data && data.type === type)
                        processorFunc(data.data);
                }
            });
        },
        set: function(key, value) {
            vcpqData[key] = value;
        },
        get: function(key) {
            return vcpqData[key];
        },
        setGlobal: function (name, object) {
            if (name && object) {
                window.vcpq = window.vcpq || {};
                window.vcpq[name] = object;
            }
        },
        isUpdatingCart: function () {
            return vCart.isUpdating;
        },
        processEventData: function (eventData) {
            console.log(eventData);
            var data = eventData.data;
            if (typeof data == 'string') {
                try {
                    data = JSON.parse(data);
                } catch(e) {
                    return ;
                }
            }
            if (!data) {
                return ;
            }
            switch (data.type) {
                case 'scpq-request': // submit
                    Debugger.log('> CPQ request : submit');
                    if (data.meta.afterSubmitAction == 'close') {
                        hideCPQContainer();
                    }
                    showSubmitLoader();
                    checkSubmitCancel();
                    vCart.addItems(data);
                    break;
                case 'scpq-close':
                    Debugger.log('> CPQ request : close');
                    hideCPQContainer();
                    break;
                case 'ns-cpq':
                    Debugger.log('> CPQ request : '+data.cmd);
                    Main_Core.processCPQrequest(data);
                    break;
            }
        },
        processCPQrequest: function(data) {
            var postData = {
                type: 'ns-cpq',
                cmd: data.cmd
            };
            if (data.queryKey) { // support of CE queryParent
                postData.queryKey = data.queryKey;
            }
            switch (data.cmd) {
                case 'get-user-profile':
                    userProfile.getUserProfile().then(function(userProfileData){
                        postData.data = userProfileData;
                        Main_Core.postMessage(postData);
                    });
                    break;
                case 'get-theme':
                    postData.data = getThemeVariables();
                    Main_Core.postMessage(postData);
                    break;
            }
        },
        initCPQContainer: function (startNewTab) {
            //
            var parent = jQuery('body'),
                containerHtml = '<div id="vcpq-container"><div id="vcpq-container-inner"><div id="vcpq-container-header"></div><div id="vcpq-container-iframe"><iframe id="vcpq-frame"></div></div></div>',
                loaderHtml = '<div class="vcpq-submit-shader vcpq-submit-loader"></div><div class="vcpq-submit-popup-wrapper vcpq-submit-loader"><div class="vcpq-submit-popup vcpq-submit-loader"><div class="vcpq-loader-text"><span>Adding items to Cart</span><div class="vcpq-loader-icon"><svg viewBox="-18 -18 36 36" role="img" aria-label="Loading" class="vcpq-loader-circular"><circle fill="none" r="16" class="vcpq-loader-circular-outline" stroke-dasharray="100" style="stroke-dashoffset: 0;"></circle><circle fill="none" r="16" class="vcpq-loader-circular-runner" stroke-dasharray="100" style="stroke-dashoffset: 75;"></circle></svg></div></div><div class="vcpq-loader-buttons"><button onclick="vcpq.cancelSubmit()">Cancel</button></div></div></div>',
                container,
                loader = jQuery(loaderHtml);
            Debugger.log('# init cpq container');
            parent.prepend(loader);
            if (!startNewTab) {
                container = jQuery(containerHtml);
                parent.prepend(container);
            }
        },
        fireEvent: function (type, data) {
            switch (type) {
                case 'ready':
                    extensionEvents['ready'].resolve(data);
                    break;
                default:
                    Debugger.error('fireEvent: unknown event - '+type);
            }
        },
        _init: function() {
            extensionEvents.ready = new jQuery.Deferred();
            Debugger.setGlobal('main_core', this);
            Debugger.setGlobal('addEventHandler', addEventHandler);
            ExtNoscroll.init();
        }
    };
    return Main_Core;
    function addEventHandler(type, fn) {
        if (!type) {
            Debugger.error('addEventHandler: event type not set');
            return ;
        }
        if (typeof fn !== 'function') {
            Debugger.error('addEventHandler: handler function not set');
            return ;
        }
        switch (type) {
            case 'ready':
                extensionEvents['ready'].done(fn);
                break;
            default:
                Debugger.error('addEventHandler: unknown event - '+type);
        }
    }
    /**
     * Finish submit process: close Item Quick View window, hide progress loader
     */
    function finishSubmit() {
        //
        Debugger.log('SUBMIT FINISH !','',true);
        jQuery('button.global-views-modal-content-header-close').click();
        hideSubmitLoader();
    }
    //
    function cancelSubmit() {
        vcpqData.cancel = true;
        hideSubmitLoader();
    }
    function checkSubmitCancel() {
        if (vcpqData.cancel) {
            vcpqData.cancel = false;
            return true;
        }
    }
    //
    function hideCPQContainer() {
        //
        ExtNoscroll.enable();
        jQuery('#vcpq-container').hide();
        jQuery('#vcpq-frame').removeAttr('src');
        cpqWindow = null;
    }
    function showCPQContainer(url, hidden) {
        //
        if (!hidden) {
            ExtNoscroll.disable();
        }
        var iframe =jQuery('#vcpq-frame');
        iframe.prop('src', url);
        if (!hidden)
            jQuery('#vcpq-container').show();
        cpqWindow = iframe[0].contentWindow;
    }
    function showSubmitLoader() {
        jQuery('.vcpq-submit-loader').show();
    }
    function hideSubmitLoader() {
        jQuery('.vcpq-submit-loader').hide();
        setLoaderFill(0);
    }
    function setLoaderFill(added, total) {
        //
        var div = jQuery('.vcpq-loader-bar-fill'), value;
        //
        value = total ? (Math.round((added / total)*100))+'%' : '0';
        div.css('width', value);
    }
    /**
     * Shopping cart operation module
     * @param {object} cart - SCA Cart object
     * @constructor
     */
    function VCart(cart) {
        //
        var _this = this;
        this.isUpdating = false;
        this.addedItems = 0;
        this.totalItems = 0;
        this.cart = cart;
        this.queueAdd = [];
        this.queueUpdate = [];
        this.queueDelete = [];
        /**
         * Get shopping cart items which belong to the current configuration
         * @param {string} transid - breakout item transid
         * @param {number} configId - configuration id
         * @returns {object} existing main and breakout items
         */
        this.getExItems = function(transid, configId) {
            //
            var def = jQuery.Deferred();
            this.cart.getLines().then(function(data) {
                var brItems = [],
                    cfgItem, out;
                //
                data.forEach(function(line) {
                    //
                    line.options.forEach(function(opt) {
                        //
                        if (opt.cartOptionId == "custcol_scpq_item_opt_config_data") {
                            var cfgData = opt.value.internalid;
                            try {
                                if (!isNaN(cfgData) && cfgData == configId) {
                                    cfgItem = line.internalid;
                                } else {
                                    cfgData = JSON.parse(cfgData);
                                    if (cfgData.transid == transid) {
                                        var item = {
                                            id: line.item.internalid, line: line.internalid
                                        };
                                        if (cfgData.dup)
                                            item.dup = cfgData.dup;
                                        if (cfgData.grp)
                                            item.grp = cfgData.grp;
                                        brItems.push(item);
                                    }
                                }
                            } catch(e) { }
                        }
                    });
                });
                out = {
                    brItems: brItems
                };
                if (cfgItem)
                    out.cfgItem = cfgItem;
                /* data format example
                {
                    cfgItem: 'item16set1064',
                    brItems: [
                        {id: 387: dup: 1, grp: 'A', line: 'item16set1065'},
                        {id: 401: dup: 1, grp: 'B', line: 'item16set1066'}
                    ]
                }
                */
                def.resolve(out);
            });
            return def;
        };
        /**
         * Add items to cart (entry point)
         * @param {object} data - CPQ submit data (configID, productID, items, other data)
         */
        this.addItems = function (data) {
            //
            Debugger.log('CPQ : Add items to Cart', data);
            var d = jQuery.Deferred(), exItemData,
                transid = data.meta.isUpdate ? data.transid : null,
                configId = data.meta.configId;
            if (transid) {
                // submit after edit
                this.getExItems(transid, configId).then(function (exData) {
                    //
                    if (exData && (exData.cfgItem || exData.brItems && Object.keys(exData.brItems).length)) {
                        exItemData = exData;
                    }
                    d.resolve();
                });
            } else {
                d.resolve();
            }
            d.done(function () {
                _this.preprareItems(data, exItemData);
                if (checkSubmitCancel())
                    return;
                _this.processItems().done(function () {
                    finishSubmit();
                });
            });
        };
        /**
         * Prepare item lists (to be added, updated, deleted)
         * @this VCart
         * @param {object} data - CPQ submit data
         * @param {object} exData - existing items
         */
        this.preprareItems = function (data, exData) {
            //
            var cfgItemLineId = exData ? exData.cfgItem : null;
            this.addedItems = 0;
            this.totalItems = 0;
            this.queueAdd = [];
            this.queueUpdate = [];
            this.queueDelete = [];
            // prepare add/update list
            if (data.soleItem) {
                this.pushItem(data.soleItem, cfgItemLineId);
            }
            if (data.bItems && data.bItems.length) {
                var exBrItems = exData ? exData.brItems : [];
                data.bItems.forEach(function (bItem) {
                    var lineId = bItem ? findLineId(bItem, exBrItems) : null;
                    _this.pushItem(bItem, lineId);
                })
            }
            // prepare delete list
            if (exData) {
                for (var i = 0; i < exData.brItems.length; i++) {
                    if (!exData.brItems[i].keep) {
                        this.queueDelete.push(exData.brItems[i].line);
                    }
                }
            }
            this.totalItems = (addOneByOne ? this.queueAdd.length : Number(!!(this.queueAdd.length))) + this.queueUpdate.length + this.queueDelete.length;
            /**
             * Find if item to be added is already in the cart
             * @param {object} item - item to be added
             * @param {array} exItems - cart items
             * @return {string} line ID
             */
            function findLineId(item, exItems) {
                var line = null;
                exItems.forEach(function (exItem) {
                    // exItem = {id: 387: dup: 1, grp: 'A', line: 'item16set1065'}
                    if ((item.item == exItem.id) && // same ID
                        (
                            (!item.grp && !exItem.grp && item.dup == exItem.dup) || // no group, same dup
                            (item.grp && item.grp == exItem.grp) // same group
                        )
                    ) {
                        line = exItem.line;
                        exItem.keep = true;
                    }
                });
                return line;
            }
        };
        /**
         * Process prepared item lists
         * @return {JQuery.Deferred}
         */
        this.processItems = function () {
            //
            var d = jQuery.Deferred(), fd = jQuery.Deferred();
            _this.isUpdating = true;
            fd.always (function () {
                _this.isUpdating = false;
            });
            if (_this.queueUpdate.length) {
                _this.addLinesUpdate(_this.queueUpdate).then(function () {
                    d.resolve();
                })
            } else {
                d.resolve();
            }
            d.done(function () {
                // $ update completed
                d = jQuery.Deferred();
                if (_this.queueAdd.length) {
                    var addPromise;
                    if (addOneByOne) {
                        addPromise = _this.addLinesInsertOneByOne(_this.queueAdd);
                    } else {
                        addPromise = _this.addLinesInsert(_this.queueAdd);
                    }
                    addPromise.then(function () {
                        d.resolve();
                    });
                } else {
                    d.resolve();
                }
                d.done(function () {
                    // $ insert completed
                    if (_this.queueDelete.length) {
                        _this.deleteLines(_this.queueDelete).then(function () {
                            fd.resolve();
                        })
                    } else {
                        fd.resolve();
                    }
                });
            });
            return fd;
        };
        /**
         * Put item to insert/update list
         * @param {object} item - item data
         * @param {string} lineId - line ID
         */
        this.pushItem = function(item, lineId) {
            var queueType =  lineId ? 'update' : 'add';
            var options = this.generateOptions(item),
                itemData;
            itemData = {
                quantity: item.quantity || 1,
                item: {
                    internalid: item.item
                }
            };
            if (lineId) {
                itemData.internalid = lineId;
            }
            if (options.length) {
                itemData.options = options;
            }
            Debugger.log('push item to '+queueType+' queue', itemData);
            if (lineId)
                this.queueUpdate.push(itemData);
            else
                this.queueAdd.push(itemData);
        };
        /**
         * Insert new items (single run)
         * @param {array} items - items to be added
         * @return {JQuery.Deferred}
         */
        this.addLinesInsert = function (items) {
            Debugger.log('Cart : add items', items);
            var op = this.cart.addLines({
                lines: items
            });
            op.then(function() {
                Debugger.log('[ Items added ('+items.length+') ]', '', true);
                _this.addedItems++;
                setLoaderFill(_this.addedItems, _this.totalItems);
            });
            op.fail(function (data) {
                var errorTitle = 'Error adding item(s) to the Cart',
                    errorDetails = data ? data.responseJSON || 'Unexpected error' : 'Unexpected error',
                    errorMessage = errorDetails ? errorDetails.errorMessage || errorDetails : errorDetails;
                Debugger.error(errorTitle, errorDetails);
                alert(errorTitle+': '+errorMessage);
                hideSubmitLoader();
            });
            return op;
        };
        /**
         * Insert new items (multiple runs)
         * @param {array} items - items to be added
         * @return {JQuery.Deferred}
         */
        this.addLinesInsertOneByOne = function (items) {
            var idx = -1, def = jQuery.Deferred();
            loopItems();
            function loopItems() {
                idx++;
                var item = items[idx], op;
                if (item && !checkSubmitCancel()) {
                    Debugger.log('Cart : add item', item);
                    op = _this.cart.addLine({line: item});
                    op.then(function() {
                        Debugger.log('[ Item added ]', '', true);
                        _this.addedItems++;
                        setLoaderFill(_this.addedItems, _this.totalItems);
                    });
                    op.then(loopItems);
                    op.fail(function (data) {
                        var errorTitle = 'Error adding item to the Cart',
                            errorDetails = data ? data.responseJSON || 'Unexpected error' : 'Unexpected error',
                            errorMessage = data ? (data.responseJSON ? data.responseJSON.errorMessage || errorDetails : errorDetails) : errorDetails;
                        Debugger.error(errorTitle, errorDetails);
                        alert(errorTitle+': '+errorMessage);
                        hideSubmitLoader();
                    });
                } else {
                    def.resolve();
                }
            }
            return def;
        };
        /**
         * Update existing items (multiple runs)
         * @param {array} items - items to be updated
         * @return {JQuery.Deferred}
         */
        this.addLinesUpdate = function (items) {
            var idx = -1, def = jQuery.Deferred();
            loopItems();
            function loopItems() {
                idx++;
                var item = items[idx], op;
                if (item && !checkSubmitCancel()) {
                    Debugger.log('Cart : update item', item);
                    op = _this.cart.updateLine({line: item});
                    op.then(function() {
                        Debugger.log('[ Item updated ]', '', true);
                        _this.addedItems++;
                        setLoaderFill(_this.addedItems, _this.totalItems);
                    });
                    op.then(loopItems);
                    op.fail(function (data) {
                        var errorTitle = 'Error updating item in the Cart',
                            errorDetails = data ? data.responseJSON || 'Unexpected error' : 'Unexpected error',
                            errorMessage = data ? (data.responseJSON ? data.responseJSON.errorMessage || errorDetails : errorDetails) : errorDetails;
                        Debugger.error(errorTitle, errorDetails);
                        alert(errorTitle+': '+errorMessage);
                        hideSubmitLoader();
                    });
                } else {
                    def.resolve();
                }
            }
            return def;
        };
        /**
         * Delete items (multiple runs)
         * @param {array} items - items to be deleted
         * @return {JQuery.Deferred}
         */
        this.deleteLines = function(items) {
            //
            var idx = -1, d = jQuery.Deferred();
            Debugger.log('*** delete items', items);
            //
            if (items.length) {
                loopDeleteLines();
            }
            //
            function loopDeleteLines() {
                //
                idx++;
                var lineId = items[idx];
                if (lineId) {
                    deleteLine(lineId).then(loopDeleteLines);
                } else {
                    d.resolve();
                }
            }
            //
            function deleteLine(lineId) {
                //
                return cart.removeLine({
                    "line_id": lineId
                }).then(function() {
                    Debugger.log("* line removed successfully : "+lineId);
                }, function(data) {
                    var errorTitle = 'Error deleting item(s) from the Cart',
                        errorDetails = data ? data.responseJSON || 'Unexpected error' : 'Unexpected error',
                        errorMessage = data ? (data.responseJSON ? data.responseJSON.errorMessage || errorDetails : errorDetails) : errorDetails;
                    Debugger.error(errorTitle, errorDetails);
                    alert(errorTitle+': '+errorMessage);
                });
            }
            return d;
        };
        /**
         * Generate options for the item (config data, price, description)
         * @param {object} item
         * @return {Array} item options in SC format
         */
        this.generateOptions = function(item) {
            //
            var options = [], parsedCols, key, sp, hasOptions;
            putOption("custcol_scpq_item_opt_config_data", item.configData);
            putOption("custcol_scpq_item_opt_price", item.rate);
            putOption("custcol_scpq_item_opt_desc", item.description);
            if (item.cpqMessage)
                putOption('custcol_scpq_item_opt_msg', item.cpqMessage);
            try {
                parsedCols = typeof item.ordCols === 'string' ? JSON.parse(item.ordCols) : item.ordCols;
                for (key in parsedCols) {
                    //
                    sp = key.split(':');
                    if (sp[1] == 'option') {
                        hasOptions = true;
                        Debugger.log('option : ', key);
                        putOption(sp[0], parsedCols[key]);
                        delete parsedCols[key];
                    }
                }
                putOption("custcol_scpq_item_opt_ordcols", JSON.stringify(parsedCols));
            } catch (e) {}
            return options;
            //
            function putOption(name, data) {
                if (data === undefined)
                    return;
                data = (typeof data == 'object') ? JSON.stringify(data) : data.toString();
                options.push({
                    cartOptionId: name,
                    value: {
                        internalid: data
                    }
                });
            }
        };
        /**
         * Clear cart
         * @return {JQuery.Deferred}
         */
        this.clear = function () {
            //
            var d = jQuery.Deferred();
            this.cart.getLines().then(function(data) {
                //
                var items = [], idx = -1, status = 'ok';
                data.forEach(function(line) {
                    items.push(line.internalid);
                });
                if (items.length) {
                    Debugger.log('Clearing Cart: '+items.length+' items');
                    loopDeleteLines();
                }
                //
                function loopDeleteLines() {
                    idx++;
                    var lineId = items[idx];
                    if (lineId) {
                        deleteLine(lineId).then(loopDeleteLines);
                    } else {
                        Debugger.log('Cart cleared: '+status);
                        d.resolve(status);
                    }
                }
                //
                function deleteLine(lineId) {
                    return _this.cart.removeLine({
                        "line_id": lineId
                    }).then(function() {
                        Debugger.log("* line removed successfully : "+lineId);
                        _this.addedItems++;
                        setLoaderFill(_this.addedItems, _this.totalItems);
                    }, function() {
                        Debugger.error("An error occurred while trying to remove the item. Try again.");
                        status = 'some items are not deleted';
                    });
                }
            });
            return d;
        }
    }
    function getThemeVariables() {
        var computedStyleMap = document.documentElement.computedStyleMap();
        var variables = {};
        computedStyleMap.forEach(function(val, name) {
            if (name.indexOf('--') === 0) {
                var value = val[0][0];
                var regex = /wrap\(".*?",(.*?)(?:\s*\))/;
                var match = value.match(regex);
                if (match) {
                    value = match[1].trim();
                }
                variables[name] = value;
            }
        });
        variables['--sc-main-background'] = getStyle('backgroundColor', ['.product-details-full', '.cart-detailed', '.facets-facet-browse', '#content', '#main-container', '#layout', '#main', 'body']);
        variables['--sc-header-background-color'] = getStyle('backgroundColor', ['.header-main-wrapper', '#site-header']);
        variables['--sc-main-navigation-background-color'] = getStyle('backgroundColor', ['.header-secondary-wrapper', '#site-header']);
        variables['--sc-header-box-shadow'] = getStyle('boxShadow', ['#site-header']);
        var mainBackgroundLightness = calculateLightness(variables['--sc-main-background']);
        if (mainBackgroundLightness < 50) {
            var lightMax = variables['--sc-color-theme-light-max'],
                light = variables['--sc-color-theme-light'],
                dark = variables['--sc-color-theme-dark'],
                darkMax = variables['--sc-color-theme-dark-max'];
            variables['--sc-color-theme-light-max'] = darkMax;
            variables['--sc-color-theme-light'] = dark;
            variables['--sc-color-theme-dark'] = light;
            variables['--sc-color-theme-dark-max'] = lightMax;
        }
        return variables;
        function getStyle(styleName, selectors) {
            for (var i = 0; i < selectors.length; i++) {
                var selector = selectors[i];
                var element = document.querySelector(selector);
                if (element) {
                    var styleValue = getComputedStyle(element)[styleName];
                    if (styleValue && (styleName !== 'backgroundColor' || styleValue !== 'rgba(0, 0, 0, 0)')) {
                        return styleValue;
                    }
                }
            }
            return '';
        }
        function calculateLightness(color) {
            // Create a temporary HTML element
            var tempDiv = document.createElement('div');
            tempDiv.style.color = color;
            tempDiv.style.display = 'none';
            document.body.appendChild(tempDiv);
            // Get the computed style of the element
            var computedColor = window.getComputedStyle(tempDiv).color;
            // Extract the RGB values from the computed color
            var matchColors = computedColor.match(/\d+/g);
            var r = parseInt(matchColors[0]);
            var g = parseInt(matchColors[1]);
            var b = parseInt(matchColors[2]);
            // Calculate the lightness using the HSL color model
            var max = Math.max(r, g, b);
            var min = Math.min(r, g, b);
            var lightness = ((max + min) / 2) / 255 * 100;
            // Remove the temporary HTML element
            document.body.removeChild(tempDiv);
            return lightness;
        }
    }
});
